const constants = {
  BASE_API_URL: "/api/v1",
  HUYGENS: "huygens",
  DORDRECHT5D: "dordrecht5D",
  CANALS5D: "canals5D",
  HUYGENS_PLAYSTORE_LINK:
    "https://play.google.com/store/apps/details?id=nl.stichtingverborgenstad.delfshaven",
  HUYGENS_APPSTORE_LINK: "https://apps.apple.com/us/app/id1521224473",
  DORDRECHT5D_APPSTORE_LINK: "https://apps.apple.com/us/app/id1530005516",
  DORDRECHT5D_PLAYSTORE_LINK:
    "https://play.google.com/store/apps/details?id=nl.stichtingverborgenstad.dordrecht",
  CANALS5D_APPSTORE_LINK: "https://apps.apple.com/us/app/canals5d/id1539595486",
  CANALS5D_PLAYSTORE_LINK:
    "https://play.google.com/store/apps/details?id=nl.stichtingverborgenstad.canals5d",
  ...getAppUrls()
};

function getAppUrls() {
  if (process.env.VUE_APP_DEPLOY_ENV == "develop") {
    return {
      HUYGENS_URL: "https://localhost:8082",
      DORDRECHT5D_URL: "https://localhost:8081",
      CANALS5D_URL: "https://localhost:8080"
    };
  }

  if (process.env.VUE_APP_DEPLOY_ENV == "production") {
    return {
      HUYGENS_URL: "https://www.huygenstijdmachine.nl",
      DORDRECHT5D_URL: "https://www.dordrecht5d.nl",
      CANALS5D_URL: "https://www.canals5d.nl"
    };
  }

  if (process.env.VUE_APP_DEPLOY_ENV == "staging") {
    return {
      HUYGENS_URL: "https://staging.huygenstijdmachine.nl",
      DORDRECHT5D_URL: "https://staging.dordrecht5d.nl",
      CANALS5D_URL: "https://staging.canals5d.nl"
    };
  }

  if (process.env.VUE_APP_DEPLOY_ENV == "test") {
    return {
      HUYGENS_URL: "https://svsdelfshaventest.yipyip.nl",
      DORDRECHT5D_URL: "https://svsdordrechttest.yipyip.nl",
      CANALS5D_URL: "https://svscanals5dtest.yipyip.nl"
    };
  }
}

export default constants;
